import { type Time } from "./model";

export default function isInTime(
  time: string | undefined,
  start: Time,
  end: Time,
) {
  if (!time) {
    return true;
  }

  // Convert HH:MM string to minutes since midnight
  const [hours, minutes] = time.split(":").map(Number);
  const timeInMinutes = hours * 60 + (minutes || 0);

  // Convert start/end times to minutes (handling decimal hours like 5.5)
  const startInMinutes = start === null ? 0 : Math.round(start * 60);
  const endInMinutes = end === null ? 24 * 60 : Math.round(end * 60);

  const afterStartTime = start === null || startInMinutes <= timeInMinutes;
  const beforeEndTime = end === null || timeInMinutes <= endInMinutes;

  return afterStartTime && beforeEndTime;
}
